/**
 * @generated SignedSource<<27f7a747c5c4bfba80089f91be0f671c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BillingSettingsDialog_billingSettings$data = {
  readonly billingCreditsLimit: number;
  readonly billingEmailAddress: string;
  readonly enabled: boolean;
  readonly invoiceTemplate: string | null;
  readonly ownerUid: string;
  readonly platform: string;
  readonly " $fragmentType": "BillingSettingsDialog_billingSettings";
};
export type BillingSettingsDialog_billingSettings$key = {
  readonly " $data"?: BillingSettingsDialog_billingSettings$data;
  readonly " $fragmentSpreads": FragmentRefs<"BillingSettingsDialog_billingSettings">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BillingSettingsDialog_billingSettings",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "platform",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ownerUid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "billingCreditsLimit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "billingEmailAddress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "invoiceTemplate",
      "storageKey": null
    }
  ],
  "type": "BillingSettings",
  "abstractKey": null
};

(node as any).hash = "25e6c7fa2e233437bd3da5b2fcf591c1";

export default node;
